import { call, takeLatest, select } from 'redux-saga/effects';
import {
  getService,
  getServices,
  addNewService,
  deleteServices,
  updateService,
  addServiceUploads,
  deleteServiceUploads,
} from 'actions/services';
import {
  getServiceApi,
  getServicesApi,
  addNewServiceApi,
  deleteServicesApi,
  updateServiceApi,
} from 'services/services';
import { addUploadApi, deleteUploadApi } from 'services/uploads';
import { getUserData } from 'selectors/users';
import fetchEntity from './fetch-entity';

const fetchService = fetchEntity.bind(null, getService.actions, getServiceApi);
const fetchServices = fetchEntity.bind(null, getServices.actions, getServicesApi);
const fetchAddNewService = fetchEntity.bind(
  null,
  addNewService.actions,
  addNewServiceApi,
);

const fetchUpdateService = fetchEntity.bind(
  null,
  updateService.actions,
  updateServiceApi,
);

const fetchDeleteServices = fetchEntity.bind(
  null,
  deleteServices.actions,
  deleteServicesApi,
);

const fetchAddServiceUploads = fetchEntity.bind(
  null,
  addServiceUploads.actions,
  addUploadApi,
);

const fetchDeleteServiceUploads = fetchEntity.bind(
  null,
  deleteServiceUploads.actions,
  deleteUploadApi,
);

export function* loadUpdateServices({ params }) {
  const userData = yield select(getUserData);
  yield call(fetchUpdateService, { ...params, values: { ...params.values, userId: userData.id } });
}

function* watchUpdateServices() {
  yield takeLatest(updateService.actionName, loadUpdateServices);
}

export function* loadGetServices({ params }) {
  const userData = yield select(getUserData);
  yield call(fetchServices, {
    ...params, '$sort[updatedAt]': -1, userId: userData.id,
  });
}

function* watchGetServices() {
  yield takeLatest([getServices.actionName], loadGetServices);
}

export function* loadGetService({ params }) {
  const userData = yield select(getUserData);
  yield call(fetchService, {
    ...params, '$sort[updatedAt]': -1, userId: userData.id,
  });
}

function* watchGetService() {
  yield takeLatest([getService.actionName], loadGetService);
}

export function* loadGetServicesOnChange({ params }) {
  const type = yield select((state) => state.services.type);
  const services = yield select((state) => state.services[type]);
  const userData = yield select(getUserData);
  const { total, skip, limit } = services;
  if (skip && skip >= total) {
    yield call(fetchServices, {
      $skip: total - Math.max(total % limit, limit),
      '$sort[updatedAt]': -1,
      userId: userData.id,
      type,
    });
  } else {
    yield call(fetchServices, {
      $skip: skip,
      '$sort[updatedAt]': -1,
      userId: userData.id,
      type,
    });
  }
}

function* watchGetServicesOnChange() {
  yield takeLatest([
    deleteServices.requestTypes.SUCCESS,
  ], loadGetServicesOnChange);
}

export function* loadAddNewService({ params }) {
  const userData = yield select(getUserData);
  yield call(fetchAddNewService, { ...params, userId: userData.id });
}

function* watchAddNewService() {
  yield takeLatest(addNewService.actionName, loadAddNewService);
}

export function* loadDeleteServices({ params }) {
  yield call(fetchDeleteServices, { ...params });
}

function* watchDeleteServices() {
  yield takeLatest(deleteServices.actionName, loadDeleteServices);
}

export function* loadAddServiceUploads({ params }) {
  yield call(fetchAddServiceUploads, { ...params });
}

function* watchAddServiceUploads() {
  yield takeLatest(addServiceUploads.actionName, loadAddServiceUploads);
}

export function* loadDeleteServiceUploads({ params }) {
  yield call(fetchDeleteServiceUploads, { ...params });
}

function* watchDeleteServiceUploads() {
  yield takeLatest(deleteServiceUploads.actionName, loadDeleteServiceUploads);
}

export default {
  watchGetService,
  watchGetServices,
  watchAddNewService,
  watchDeleteServices,
  watchUpdateServices,
  watchAddServiceUploads,
  watchDeleteServiceUploads,
  watchGetServicesOnChange,
};
